"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CollectionComplaintResolutionEnum = void 0;
/** Решения по жалобе на коллекцию */
var CollectionComplaintResolutionEnum;
(function (CollectionComplaintResolutionEnum) {
  /** Отклонено */
  CollectionComplaintResolutionEnum[CollectionComplaintResolutionEnum["rejected"] = 10] = "rejected";
  /** Отправлено на модерацию */
  CollectionComplaintResolutionEnum[CollectionComplaintResolutionEnum["moderation"] = 20] = "moderation";
  /** Снято с публикации */
  CollectionComplaintResolutionEnum[CollectionComplaintResolutionEnum["unpublished"] = 30] = "unpublished";
  /** Автор забанен */
  CollectionComplaintResolutionEnum[CollectionComplaintResolutionEnum["banned"] = 40] = "banned";
  /** Произведено возмещение, включая частичное */
  CollectionComplaintResolutionEnum[CollectionComplaintResolutionEnum["refunded"] = 500] = "refunded";
  /** Закрыто */
  CollectionComplaintResolutionEnum[CollectionComplaintResolutionEnum["closed"] = 1000] = "closed";
})(CollectionComplaintResolutionEnum = exports.CollectionComplaintResolutionEnum || (exports.CollectionComplaintResolutionEnum = {}));
